import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form, Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  TabPane,
  NavLink,
  TabContent,
  NavItem,
  Nav
} from "reactstrap";

import { withRouter } from "react-router-dom";

import Select from "react-select";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UserProfile = () => {
  //meta title
  document.title = "Profile";
  const { getRequest, postRequest } = useRequests();


  const [activeTab, setActiveTab] = useState("1");


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [formData1, setFormData1] = React.useState({
		country: {label: 'Spain', value: 'Spain'},
	});
  const [CustomError1, setCustomError1] = React.useState({
		country: '',
	});
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      first_name: '',
      last_name: '',
      phone: '',
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required('First Name is required'),
      last_name: Yup.string()
        .required('Last Name is required'),
      phone: Yup.string()
        .matches(
          /^[#0-9]+$/,
          'Please enter a valid value!'
        )
        .required('Mobile Number is required')
        .max(10, 'Mobile Number should not be greater than 10 digits!'),
    }),
    onSubmit: async (values) => {
      try {
        setCustomError1({
          ...CustomError1,
          country: '',
        });

        if (formData1.country === null) {
          setCustomError1({
						...CustomError1,
						country: 'Please select country',
					});
        } else {
          let submit1 = document.getElementById('submit1');
          submit1.disabled = true;
          submit1.textContent = 'Processing...';

          const jsonpar = JSON.stringify({
            first_name: values.first_name,
            last_name: values.last_name,
            phone: values.phone,
            country: formData1.country.value,
          });
          const res = await postRequest('update-profile', jsonpar);
          if (res && res.code === 200) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit1.disabled = false;
          submit1.textContent = 'Update Profile';
        }
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;
      
      let tempArr = [];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesData(tempArr);

      handleLoadGetAdminInfo();
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const handleLoadGetAdminInfo = async () => {
    const res = await getRequest('get-admin-info');
    if (res && res.code === 200) {
      let originalText = res.data;
      
      validation1.setValues({
        ...validation1.values,
        first_name: originalText.first_name,
        last_name: originalText.last_name,
        phone: originalText.phone,
      });
      setFormData1({ ...formData1, country: {label: originalText.country, value: originalText.country} });
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  React.useEffect(() => {
    handleLoadGetAllCountries();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Tokenizedgreen" breadcrumbItem="Update Profile" />
          <Row>
            <Col lg="12">
              <div className="crypto-buy-sell-nav">
                <Card className="">
                  <CardBody className="p-0">
                    <TabContent activeTab={activeTab} className="crypto-buy-sell-nav-content p-4" >
                      <TabPane tabId="1" id="buy">
                        <form>
                          <Row>
                            <Col xs="12">
                              <Row>
                                <Col md={6} xs={12}>
                                  <div className="mb-3">
                                    <Label className="form-label">First name :</Label>
                                    <Input name="first_name" type="text" placeholder="Enter first name"
                                      onChange={validation1.handleChange}
                                      onBlur={validation1.handleBlur}
                                      value={validation1.values.first_name || ""}
                                      invalid={
                                        validation1.touched.first_name && validation1.errors.first_name ? true : false
                                      }
                                    />
                                    {validation1.touched.first_name && validation1.errors.first_name ? (
                                      <FormFeedback type="invalid">{validation1.errors.first_name}</FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col md="6" xs="12">
                                  <div className="mb-3">
                                    <Label className="form-label">Last name :</Label>
                                    <Input name="last_name" type="text" placeholder="Enter last name"
                                      onChange={validation1.handleChange}
                                      onBlur={validation1.handleBlur}
                                      value={validation1.values.last_name || ""}
                                      invalid={
                                        validation1.touched.last_name && validation1.errors.last_name ? true : false
                                      }
                                    />
                                    {validation1.touched.last_name && validation1.errors.last_name ? (
                                      <FormFeedback type="invalid">{validation1.errors.last_name}</FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6} xs={12}>
                                  <div className="mb-3 Register-Select2">
                                    <Label className="form-label">Select country :</Label>
                                      <Select styles={colourStyles} value={formData1.country} onChange={(e) => setFormData1({ ...formData1, country: e })} options={AllCountriesData} classNamePrefix="select2-selection" />
                                      {CustomError1.country !== '' ? (<FormFeedback type="invalid" style={{ display: 'block' }}>{CustomError1.country}</FormFeedback>
                                      ): null}
                                  </div>
                                </Col>
                                <Col md={6} xs={12}>
                                  <div className="mb-3">
                                    <Label>Mobile no. :</Label>
                                    <Input type="text" className="form-control" placeholder="Enter mobile no"
                                      name="phone"
                                      onChange={validation1.handleChange}
                                      onBlur={validation1.handleBlur}
                                      value={validation1.values.phone || ""}
                                      invalid={
                                        validation1.touched.phone && validation1.errors.phone ? true : false
                                      }
                                    />
                                    {validation1.touched.phone && validation1.errors.phone ? (
                                      <FormFeedback type="invalid">{validation1.errors.phone}</FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </form>
                        <div className="text-left">
                          <Button type="button" color="primary"
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          >Update Profile</Button>
                        </div>
                      </TabPane>

                    </TabContent>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
